import { useEffect, useState } from 'react'
import { WifiOff, Wifi } from 'lucide-react'

export function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [showOffline, setShowOffline] = useState(false)
  const [showReconnected, setShowReconnected] = useState(false)

  useEffect(() => {
    let reconnectTimeout: ReturnType<typeof setTimeout>

    const handleOnline = () => {
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout)
      }
      setIsOnline(true)
      setShowOffline(false)
      setShowReconnected(true)

      reconnectTimeout = setTimeout(() => {
        setShowReconnected(false)
      }, 3000)
    }

    const handleOffline = () => {
      setIsOnline(false)
      setShowOffline(true)
      setShowReconnected(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    if (!navigator.onLine) {
      setIsOnline(false)
      setShowOffline(true)
    }

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
      if (reconnectTimeout) clearTimeout(reconnectTimeout)
    }
  }, [])

  if (isOnline && !showReconnected) {
    return null
  }

  return (
    <>
      {/* Offline Banner */}
      {showOffline && (
        <div className="fixed top-0 left-0 right-0 z-[9999] bg-ss-critical-200 text-white shadow-lg animate-in slide-in-from-top duration-300">
          <div className="container mx-auto px-4 py-3">
            <div className="flex items-center justify-center gap-3">
              <WifiOff className="h-5 w-5 animate-pulse" />
              <p className="text-sm font-semibold">
                No internet connection. Please check your network settings.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Reconnected Banner */}
      {showReconnected && (
        <div className="fixed top-0 left-0 right-0 z-[9999] bg-ss-positive-200 text-white shadow-lg animate-in slide-in-from-top duration-300">
          <div className="container mx-auto px-4 py-3">
            <div className="flex items-center justify-center gap-3">
              <Wifi className="h-5 w-5" />
              <p className="text-sm font-semibold">
                Back online! Your connection has been restored.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Spacer to prevent content from being hidden under banner */}
      {(showOffline || showReconnected) && <div className="h-12" />}
    </>
  )
}
